import { render, staticRenderFns } from "./Pyyz.vue?vue&type=template&id=300a07f4&"
import script from "./Pyyz.vue?vue&type=script&lang=js&"
export * from "./Pyyz.vue?vue&type=script&lang=js&"
import style0 from "./Pyyz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports